import React from 'react';
import { Button, Container, Card, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from 'react-router-dom';

const Dashboard = () => {
  return (
    <Container>
      <h2 className="text-center my-5">Welcome to the Dashboard</h2>
      <Row className="g-4">
        <Col md={4}>
          <Card className="text-center shadow-sm">
            <Card.Img
              variant="top"
              src="/images/receipts.jpg"
              className="img-fluid"
              style={{ height: '200px', objectFit: 'cover' }}
            />
            <Card.Body>
              <Card.Title>Receipts</Card.Title>
              <Card.Text>View and manage receipts</Card.Text>
              <Button variant="primary" as={Link} to="/receipts">
                Go to Receipts
              </Button>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="text-center shadow-sm">
            <Card.Img
              variant="top"
              src="/images/invoices.jpg"
              className="img-fluid"
              style={{ height: '200px', objectFit: 'cover' }}
            />
            <Card.Body>
              <Card.Title>Invoices</Card.Title>
              <Card.Text>View and manage invoices</Card.Text>
              <Button variant="primary" as={Link} to="/invoices">
                Go to Invoices
              </Button>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="text-center shadow-sm">
            <Card.Img
              variant="top"
              src="/images/services.jpg"
              className="img-fluid"
              style={{ height: '200px', objectFit: 'cover' }}
            />
            <Card.Body>
              <Card.Title>Services</Card.Title>
              <Card.Text>View and manage services</Card.Text>
              <Button variant="primary" as={Link} to="/services">
                Go to Services
              </Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Dashboard;
